"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CirclePainter = void 0;
var ShapePainter_1 = require("../ShapePainter");
var round_1 = require("../../../util/round");
var antiAliasSize = 1;
/**
 * Implements drawing-related operations for circles.
 */
var CirclePainter = /** @class */ (function (_super) {
    __extends(CirclePainter, _super);
    function CirclePainter() {
        var _this = _super.call(this, "circle") || this;
        _this.baseWidthOf = function (object) { return object.radius * 2; };
        _this.baseHeightOf = function (object) { return object.radius * 2; };
        return _this;
    }
    CirclePainter.prototype.tracePath = function (ctx, store, object) {
        ctx.save();
        var targetWidth = round_1.round(object, this.scaledBaseWidthOf(object));
        var targetHeight = round_1.round(object, this.scaledBaseHeightOf(object));
        ctx.translate(0.5, 0.5);
        ctx.scale((targetWidth - antiAliasSize) / this.baseWidthOf(object), (targetHeight - antiAliasSize) / this.baseHeightOf(object));
        ctx.beginPath();
        ctx.arc(object.radius, object.radius, object.radius, 0, 2 * Math.PI);
        ctx.closePath();
        ctx.restore();
    };
    return CirclePainter;
}(ShapePainter_1.ShapePainter));
exports.CirclePainter = CirclePainter;
//# sourceMappingURL=CirclePainter.js.map